export default {
    discipleTree(state) {
        return state.discipleTree;
    },
    error(state) {
        return state.error;
    }
};
